import { PersistQueryClientProvider } from '@tanstack/react-query-persist-client';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { createQueryClient, persistOptions } from './api/queries.ts';
import { App } from './App.tsx';
import './styles/tokens.css';
import './styles/base.css';
import { initTelegram } from './telegram/tg.ts';

initTelegram();

const root = document.getElementById('root');
if (!root) throw new Error('#root not found');

const queryClient = createQueryClient();

createRoot(root).render(
  <StrictMode>
    <PersistQueryClientProvider client={queryClient} persistOptions={persistOptions}>
      <App />
    </PersistQueryClientProvider>
  </StrictMode>,
);
